module.exports = __webpack_public_path__ + "media/images/team-icon-f317dd254bfe489c2df85f558cb5b6e9.svg";